import { CircularProgress } from '@mui/material'
import { userPrivilegesSSO } from 'api'
import { Container, Icon, TypoGraph } from 'components'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { isAgentLogin, isCarrierLogin, setupLoginCred } from 'tools/auth'
import bootIntercom from 'tools/intercom'
import { reportException } from 'tools/logs'
import styles from './sso.module.scss'
import colors from 'theme/colors'
import { SetCookie } from 'tools/cookies'

const SSORedirect = () => {
    const navigate = useNavigate()
    const { token, userId } = useParams()
    const [urlAuthToken, setUrlAuthToken] = useState<String>("")
    const [urlUserId, setUrlUserId] = useState<String>("")
    const [errorFromLogin, setErrorFromLogin] = useState<any>(null)

    const companyProfile = useSelector(
        (state: any) => state?.whiteLabel?.companyProfile
    )

    useEffect(() => {
        if (token && token !== "" && userId && userId !== "") {
            setUrlAuthToken(token)
            setUrlUserId(atob(userId))
        }
    }, [token, userId, navigate])

    useEffect(() => {
        if (urlAuthToken && urlUserId) {
            userPrivilegesSSO(urlAuthToken, urlUserId)
                .then((res: any) => {
                    const data = res?.data ?? res
                    bootIntercom(data?.Company_Profile?.email, data?.UserName)
                    setupLoginCred(data)
                    SetCookie('isSSO', 'true', 0.1, true)
                    
                    isCarrierLogin() ? navigate('/accounts') : isAgentLogin() ? navigate('/dashboard') : navigate('/dashboard')
                })
                .catch((error: any) => {
                    reportException(error)
                    setErrorFromLogin(error)
                })

        }
    }, [urlAuthToken, urlUserId])

    return (
        <Container className={styles.ssoLoginContainer}>
            <Container>
                {companyProfile?.favicon ? (
                <Icon
                    type="images"
                    url={companyProfile?.favicon}
                    boxClassName="fullLogo"
                    width={500}
                    height={150}
                />
                ) : (
                <Icon name={'icon_logo'} width={200} height={30} />
                )}
            </Container>
            {errorFromLogin &&
            <>
                <Container>
                    <TypoGraph
                        variant="h5"
                        content="Error on Logging in"
                        color={colors.error}
                        sx={{ textAlign: 'center' }}
                    />
                    <TypoGraph
                        variant="subtitle2"
                        content="We have encountered an error. Please contact support."
                        sx={{ textAlign: 'center' }}
                    />
                </Container>
            </>
            ||
            <>
                <Container className={styles.loader}>
                    <CircularProgress />
                </Container>
                <Container>
                    <TypoGraph
                        variant="h5"
                        content="Logging into TruckerCloud"
                        sx={{ textAlign: 'center' }}
                    />
                    <TypoGraph
                        variant="subtitle2"
                        content="We will finish the process for you, please wait..."
                        sx={{ textAlign: 'center' }}
                    />
                </Container>
            </>}
        </Container>
    )
}

export default SSORedirect